import React, { useState, useEffect } from "react";
import FTPFields from "./FTPFields.js";
import Form from "../../../../Reusable/Form/Form.js";
import parse from "html-react-parser";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import EmbedLimitOptionsModal from "../../../../Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import Button from "components/Elements/Button/Button.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import usePageInit from "hooks/usePageInit.ts";
import { Toggle } from "../../../../Elements/Toggle/Toggle.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const FtpSettings = ({ userData, availableAllPages }) => {
  const { isPageReady } = usePageInit();
  const { setModal } = useModal();
  const { getUserData } = useUser();
  const { getTextByKey, getLanguage } = useContent();
  const { addToast } = useToasts();
  const [embedSettings, setEmbedSettings] = useState(
    userData.EmbedDynamicSettings
  );
  const [isConnectToFTP, setIsConnectToFTP] = useState(
    userData?.EmbedDynamicSettings?.EmbedSettingFtpConnect ?? true
  );
  const [transferAsZIP, setTransferAsZIP] = useState(
    userData?.EmbedDynamicSettings?.EmbedSettingsTransferAsZIP ? "zip" : "unzip"
  );
  const [ftpProtocol, setFtpProtocol] = useState(
    userData?.EmbedDynamicSettings?.EmbedSettingsFTPProtocolType === 0
      ? "ftp"
      : "ftps"
  );
  const [ftpMode, setFtpMode] = useState(
    userData?.EmbedDynamicSettings?.EmbedSettingsFTPModeType === 0
      ? "passive"
      : "active"
  );
  const [loadingSaveDetails, setLoadingSaveDetails] = useState(false);
  const [loadingTestButton, setLoadingTestButton] = useState(false);
  const SaveFTPSettings = async (bodyForm) => {
    setTransferAsZIP(bodyForm.TransferType);
    setFtpProtocol(bodyForm.Protocol);
    setFtpMode(bodyForm.Mode);
    const body = {
      EmbedSettingsAPIUrl:
        getUserData().EmbedDynamicSettings &&
        getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl,
      EmbedSettingsFTPServerUrl: bodyForm.FtpHostAddress,
      EmbedSettingsFTPProtocolType: bodyForm.Protocol,
      EmbedSettingsFTPFolderPath: bodyForm.FtpFolder,
      EmbedSettingsFTPUserName: bodyForm.FtpUsername,
      EmbedSettingsFTPPassword: bodyForm.FtpPassword,
      EmbedSettingsFTPPort: bodyForm.FtpPort,
      EmbedSettingsFTPModeType: bodyForm.Mode,
      EmbedSettingsFTPConnect: isConnectToFTP,
      EmbedSettingsTransferAsZIP:
        bodyForm.TransferType === "zip" ? true : false,
      RecaptchaResponse: bodyForm.recaptchaResponse,
    };
    if (availableAllPages) {
      setLoadingSaveDetails(true);
      const response = await apiRequest(
        "EmbedDynamics",
        "UpdateFTPCredentialsReact",
        body,
        "POST"
      );
      if (response.status === "success") {
        if (response.data === 0) {
          addToast(getTextByKey("ftp-setting-saved-success"), {
            appearance: "success",
          });
          const newSettings = {
            EmbedSettingsUserId: getUserData().UserId,
            EmbedSettingsAPIUrl:
              getUserData().EmbedDynamicSettings &&
              getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl,
            EmbedSettingsFTPServerUrl: bodyForm.FtpHostAddress,
            EmbedSettingsFTPProtocolType: bodyForm.Protocol === "ftp" ? 0 : 1,
            EmbedSettingsFTPFolderPath: bodyForm.FtpFolder,
            EmbedSettingsFTPUserName: bodyForm.FtpUsername,
            EmbedSettingsFTPPassword: bodyForm.FtpPassword,
            EmbedSettingsFTPPort: bodyForm.FtpPort,
            EmbedSettingsFTPModeType: bodyForm.Mode === "passive" ? 0 : 1,
            EmbedSettingsTransferAsZIP:
              bodyForm.TransferType === "zip" ? true : false,
          };
          setEmbedSettings(newSettings);
        } else {
          addToast(getTextByKey("ftp-error") + " " + response.data, {
            appearance: "error",
          });
        }
      }
      setLoadingSaveDetails(false);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }

    return { message: "asd", status: "success" };
  };

  const deleteFTPSettings = async (bodyForm) => {
    bodyForm.FtpHostAddress = "";
    bodyForm.Protocol = "";
    bodyForm.FtpUsername = "";
    bodyForm.FtpPassword = "";
    bodyForm.FtpPort = "";
    bodyForm.Mode = "";

    const body = {
      EmbedSettingsAPIUrl:
        getUserData().EmbedDynamicSettings &&
        getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl
          ? getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl
          : "",
      EmbedSettingsAPIStatuses:
        getUserData().EmbedDynamicSettings &&
        getUserData().EmbedDynamicSettings.EmbedSettingsAPIStatuses
          ? getUserData().EmbedDynamicSettings.EmbedSettingsAPIStatuses
          : "",
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "DeleteFTPCredentialsReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === 0) {
        addToast(getTextByKey("ftp-setting-delete-success"), {
          appearance: "success",
        });
        const newSettings = {
          EmbedSettingsUserId: getUserData().UserId,
          EmbedSettingsAPIUrl:
            getUserData().EmbedDynamicSettings &&
            getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl
              ? getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl
              : "",
          EmbedSettingsFTPServerUrl: "",
          EmbedSettingsFTPProtocolType: 0,
          EmbedSettingsFTPFolderPath: "",
          EmbedSettingsFTPUserName: "",
          EmbedSettingsFTPPassword: "",
          EmbedSettingsFTPPort: "",
          EmbedSettingsFTPModeType: 0,
          EmbedSettingsTransferAsZIP: true,
        };
        setEmbedSettings(newSettings);
      } else {
        addToast(getTextByKey("ftp-error") + " " + response.data, {
          appearance: "error",
        });
      }
    }
    return { message: "asd", status: "success" };
  };

  const TestFTPSettings = async (bodyForm) => {
    setLoadingTestButton(true);
    const response = await apiRequest(
      "EmbedDynamics",
      "TestFTPCredentialsReact",
      bodyForm,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.StatusCode === 226) {
        addToast(getTextByKey("ftp-test-success"), {
          appearance: "success",
        });
      } else {
        addToast(
          getTextByKey("ftp-error") + " " + response.data.ErrorDescription,
          {
            appearance: "error",
          }
        );
      }
      setLoadingTestButton(false);
    } else {
      setLoadingTestButton(false);
    }
    const newSettings = {
      EmbedSettingsUserId: getUserData().UserId,
      EmbedSettingsAPIUrl:
        getUserData().EmbedDynamicSettings &&
        getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl,
      EmbedSettingsFTPServerUrl: bodyForm.EmbedSettingsFTPServerUrl,
      EmbedSettingsFTPProtocolType:
        bodyForm.EmbedSettingsFTPProtocolType === "ftp" ? 0 : 1,
      EmbedSettingsFTPFolderPath: bodyForm.EmbedSettingsFTPFolderPath,
      EmbedSettingsFTPUserName: bodyForm.EmbedSettingsFTPUserName,
      EmbedSettingsFTPPassword: bodyForm.EmbedSettingsFTPPassword,
      EmbedSettingsFTPPort: bodyForm.EmbedSettingsFTPPort,
      EmbedSettingsFTPModeType:
        bodyForm.EmbedSettingsFTPModeType === "passive" ? 0 : 1,
    };
    setEmbedSettings(newSettings);
  };

  const connectToFTP = async () => {
    if (availableAllPages) {
      const body = {
        EmbedSettingFtpConnect: !isConnectToFTP,
      };
      setIsConnectToFTP((prev) => !prev);

      const response = await apiRequest(
        "EmbedDynamics",
        "ConnectToFTPReact",
        body,
        "POST"
      );
      if (response.status === "success") {
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const handleTestFtpSettings = () => {
    if (availableAllPages) {
      //check if ftp fields not empty
      if (
        embedSettings.EmbedSettingsFTPServerUrl &&
        embedSettings.EmbedSettingsFTPUserName &&
        embedSettings.EmbedSettingsFTPPassword &&
        embedSettings.EmbedSettingsFTPPort
      ) {
        const bodyForm = {
          EmbedSettingsAPIUrl:
            getUserData().EmbedDynamicSettings &&
            getUserData().EmbedDynamicSettings.EmbedSettingsAPIUrl,
          EmbedSettingsFTPServerUrl: embedSettings.EmbedSettingsFTPServerUrl,
          EmbedSettingsFTPProtocolType:
            embedSettings.EmbedSettingsFTPProtocolType === 0 ? "ftp" : "ftps",
          EmbedSettingsFTPFolderPath: embedSettings.EmbedSettingsFTPFolderPath,
          EmbedSettingsFTPUserName: embedSettings.EmbedSettingsFTPUserName,
          EmbedSettingsFTPPassword: embedSettings.EmbedSettingsFTPPassword,
          EmbedSettingsFTPPort: embedSettings.EmbedSettingsFTPPort,
          EmbedSettingsFTPModeType:
            embedSettings.EmbedSettingsFTPModeType === 0 ? "passive" : "active",
          EmbedSettingsFTPConnect: isConnectToFTP,
        };
        TestFTPSettings(bodyForm);
      } else {
        addToast(getTextByKey("ftp-error-empty-fields"), {
          appearance: "error",
        });
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
    //SaveFTPSettings(bodyForm);
  };

  if (!isPageReady) {
    return null;
  }

  return (
    <div className="ftp-container">
      <div className="ftp-title">
        <h3>{getTextByKey("ftp-title")}</h3>
        <p>{parse(getTextByKey("ftp-subtitle"))}</p>
        <div className="top-actions">
          <div className="connect-to-ftp">
            <Toggle
              //onClick={() => connectToFTP()}
              status={isConnectToFTP}
              setStatus={connectToFTP}
            />{" "}
            <span>{getTextByKey("ftp-connect")}</span>
          </div>
          <div className="test-ftp">
            {embedSettings &&
              embedSettings.EmbedSettingsFTPServerUrl &&
              embedSettings.EmbedSettingsFTPUserName &&
              embedSettings.EmbedSettingsFTPPassword && (
                <Button
                  className="new-button"
                  onClick={() => handleTestFtpSettings()}
                >
                  {loadingTestButton ? (
                    <LoadingImageElement />
                  ) : (
                    getTextByKey("ftp-test-button")
                  )}
                </Button>
              )}
          </div>
        </div>
      </div>
      <div
        className={`main ${!isConnectToFTP ? "disable" : ""} ${getLanguage()} ${
          loadingSaveDetails ? "loading-ftp-form" : ""
        }`}
      >
        <Form
          ref={null}
          fields={FTPFields}
          onSubmit={SaveFTPSettings}
          onCancel={deleteFTPSettings}
          cancelProps={{
            title: getTextByKey("ftp-clear-details"),
            className: "clear-details",
          }}
          submitProps={{
            title: getTextByKey("ftp-save-changes"),
          }}
          buttonProps={{
            buttonsSize: "xs",
            buttonsDirection: "pull-to-start",
          }}
          fieldsProps={{
            label: "ftp-input-title",
            field: "ftp-inputs-field",
          }}
          defaultValuesObj={
            getUserData().EmbedDynamicSettings
              ? {
                  Protocol: ftpProtocol,
                  Mode: ftpMode,
                  FtpHostAddress: embedSettings.EmbedSettingsFTPServerUrl,
                  FtpFolder: embedSettings.EmbedSettingsFTPFolderPath,
                  FtpUsername: embedSettings.EmbedSettingsFTPUserName,
                  FtpPassword: embedSettings.EmbedSettingsFTPPassword,
                  FtpPort:
                    embedSettings.EmbedSettingsFTPPort &&
                    embedSettings.EmbedSettingsFTPPort,
                  TransferType: transferAsZIP,
                }
              : { Mode: "passive", Protocol: "ftp", TransferType: "zip" }
          }
        />
      </div>
      <div className="ftp-bottom">{parse(getTextByKey("ftp-info-text"))}</div>
    </div>
  );
};

export default FtpSettings;
